import { Plugins } from '@leverege/plugin';
export default Plugins.createFactory('CanvasOverlayLayerCreator', {
  strategy: Plugins.ALL,
  pluginKey: 'create'
});